import type { FunctionComponent } from "react";
import { useMemo } from "react";

import { tracking } from "shared/data";
import { useCurrentPageType } from "shared/hooks";

import type { ShowInVariant } from "scmp-app/components/header/features/styles";

import { Container, StyledBaseLink, StyledLogo } from "./styles";

export type HeaderFeaturesMyNewsProps = {
  showIn?: ShowInVariant;
};

export const HeaderFeaturesMyNews: FunctionComponent<HeaderFeaturesMyNewsProps> = ({ showIn }) => {
  const currentPageType = useCurrentPageType();

  const mastheadQueryParameter = useMemo(
    () => ({
      module: tracking.module.Masthead,
      pgtype: currentPageType,
    }),
    [currentPageType],
  );

  return (
    <Container $showIn={showIn}>
      <StyledBaseLink
        anchorProps={{ "aria-label": "my news" }}
        as="/mynews"
        pathname="mynews"
        query={mastheadQueryParameter}
      >
        <StyledLogo />
      </StyledBaseLink>
    </Container>
  );
};

HeaderFeaturesMyNews.displayName = "HeaderFeaturesMyNews";
